module.exports = __webpack_public_path__ + "static/media/video-exercise-list.f706c34d.mp4";